import { IAnalysisValueColumn } from "../../types"

export class HsaTableColumns {

    public columns: IAnalysisValueColumn[]

    constructor() {

        this.columns = getHsaColumns()

    }

}

export function getHsaColumns(): IAnalysisValueColumn[] {

    return [

        { name: "InfiltrationTime", units: "seconds", header: "Infiltration Time" },
        { name: "InfiltrationTapeWidth", units: "mm", header: "Infiltration Tape Width" },
        { name: "InfiltrationRate", header: "Infiltration Rate", visible: true },
        { name: "VessScore", header: "Vess Score", visible: true },

        { name: "Anecic", units: "in <sup>1</sup>/<sub>16</sub> m<sup>3</sup> of soil", header: "Anecic", visible: true },
        { name: "Endogeic", units: "in <sup>1</sup>/<sub>16</sub> m<sup>3</sup> of soil", header: "Endogeic", visible: true },
        { name: "TotalWorms", header: "Total Worms" },

        { name: "SoilPH1", header: "Soil pH Depth 1" },
        { name: "SoilPH2", header: "Soil pH Depth 2" },
        { name: "SoilPH3", header: "Soil pH Depth 3" },

        { name: "TopSoilStonePct", units: "%", header: "Top soil stone content" },
        { name: "Capping", header: "Capping" },
        { name: "DepthToCompaction", units: "cm", header: "Depth to compaction" },
        { name: "RootingDepth", units: "cm", header: "Root depth" },
        { name: "RootDensity", units: "roots/cm<sup>3</sup>", header: "Root density" },
        { name: "Drainage", header: "Drainage" },

        { name: "SubsoilStonePct", units: "%", header: "Subsoil stone content" },
        { name: "DepthToRock", units: "cm", header: "Depth to rock" },

        { name: "GrainProtein", header: "Grain protein" },
        { name: "YieldPotential", units: "t/ha", header: "Yield potential" },
        { name: "YieldPotentialPct", units: "%", header: "Yield potential %" },
        { name: "PrimaryCultivations", header: "Primary cultivations" },
        { name: "DrillType", header: "Drill type" }

    ]

}
